module.exports = __webpack_public_path__ + "static/media/013.1ab49a3e.jpg";